import { Checkbox, Menu } from '@mantine/core'
import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'
import type { TMenuColumn } from './types'

export const ColumnVisibilityMenu = ({
  columns,
  visibleColumns,
  onToggle,
  onToggleAll,
}: {
  columns: TMenuColumn[]
  visibleColumns: Record<string, boolean>
  onToggle: (key: string) => void
  onToggleAll: () => void
}) => {
  return (
    <Menu.Dropdown>
      <Menu.Label css={{ color: 'black', fontWeight: 'bolder' }}>
        {translate.phrases.banyanApp('Show/Hide Columns')}
      </Menu.Label>
      <Menu.Item>
        <div onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()}>
          <Checkbox
            css={{ fontWeight: '500' }}
            checked={Object.values(visibleColumns).every((v) => v !== false)}
            onChange={onToggleAll}
            label={translate.phrases.banyanApp('View All')}
            size="xs"
            color={colors.primary}
          />
        </div>
      </Menu.Item>

      {columns.map((column) => (
        <Menu.Item key={column.key}>
          <div onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()}>
            <Checkbox
              css={{ fontWeight: '500' }}
              checked={visibleColumns[column.key] !== false}
              onChange={() => onToggle(column.key)}
              label={column.title}
              size="xs"
              color={colors.primary}
            />
          </div>
        </Menu.Item>
      ))}
    </Menu.Dropdown>
  )
}
